module.exports = __webpack_public_path__ + "static/media/qurm_villas3.54305a38.webp";